<template>
  <div
    class="row"
    style="margin-left: 0px; margin-right: 0px"
    @mouseover="mouseOverEventHandler()"
    @mouseleave="mouseLeaveEventHandler()"
  >
    <DxGallery
      v-if="galleryDataSource.length > 0"
      :data-source="galleryDataSource"
      height="100%"
      width="100%"
      :slideshow-delay="slideshowDelay"
      :show-indicator="galleryDataSource.length > 1"
      :loop="true"
      @item-click="bannerClick"
    >
      <template #item="{ data }">
        <div
          class="banner-content flex-column"
          style="width: 100%; height: 100%"
        >
          <img :src="data.imageUrl" style="height: 100%; width: 100%" />
        </div>
      </template>
    </DxGallery>
  </div>
</template>

<script>
import DxGallery from 'devextreme-vue/gallery'
import { mapGetters } from 'vuex'

export default {
  name: 'BannerAdv',
  components: {
    DxGallery,
  },
  data: () => ({
    slideshowDelay: 8000,
    clientGalleryDataSource: null,
    partecipantGalleryDataSource: null,
    galleryDataSource: [],
    userGroups: null,
  }),
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    this.apiService.reservedAreaApi.getActiveBannerList().then(res => {
      this.galleryDataSource = [
        ...new Map(res.map(item => [item['id'], item])).values(),
      ]
    })
  },
  methods: {
    mouseOverEventHandler() {
      this.slideshowDelay = 0
    },
    mouseLeaveEventHandler() {
      this.slideshowDelay = 8000
    },
    bannerClick(e) {
      window.open(e.itemData.linkUrl, '_blank')
    },
  },
}
</script>
<style>
*,
:after,
:before {
  box-sizing: initial;
}
</style>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.banner-content {
  background-size: 100%;
}

.object-fit_fill {
  object-fit: fill;
  max-height: 200px;
}

img {
  background-color: #444;
}

img[class] {
  width: 100%;
}

.image {
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button {
  background: rgb(0, 158, 220);
}

a {
  background: rgb(0, 158, 220);
}

.display-flex {
  display: flex;
  align-items: baseline;
}

.filter-element {
  padding-left: 1rem;
}

.field-padding {
  padding-right: 20px;
}
</style>
<style>
.hidden-row {
  visibility: hidden !important;
}

.dx-texteditor-input {
  margin: 0 !important;
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.87) !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  appearance: none !important;
  outline: 0 !important;
  border: 0 !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}

.dx-gallery-indicator {
  text-align: left;
}

.dx-gallery-indicator-item {
  width: 12px;
  height: 12px;
}

.dx-gallery-indicator-item-active,
.dx-gallery-indicator-item-selected {
  background: #6c6c6c !important;
  width: 16px;
  height: 16px;
}
</style>
